import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import ReactFlagsSelect from "react-flags-select";

const CheckOut = () => {
  const { cartItems, clearCart } = useContext(CartContext);
  const [card, setCard] = useState("");
  const [date, setDate] = useState("");
  const [security, setSecurity] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [ship, setShip] = useState("");
  const [errors] = useState({});
  const navigate = useNavigate();
  const [cardName, setCardName] = useState("");
  const [contact, setContact] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [company, setCompany] = useState("");
  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const location = useLocation();
  const { sub } = location.state || {};

  const handlePlaceOrder = () => {
    const newErrors = {};
    const cardInputs = document.querySelectorAll(
      'input[name="date"], input[name="security"], input[name="cardName"],input[name="contact"], input[name="firstName"], input[name="lastName"], input[name="address"],input[name="city"], input[name="postalCode"],input[name="cardName"]'
    );
    cardInputs.forEach((input) => {
      if (input.tagName === "SELECT" || input.tagName === "INPUT") {
        if (!input.value) {
          newErrors[input.name] = "该项目必须填写";
          input.style.border = "2px solid red";
        } else {
          input.style.border = "";
        }
      }
    });
    if (!contact) newErrors.contact = "Enter an email or phone number";
    if (!postalCode) newErrors.postalCode = "Enter a ZIP / postal code";
    if (!date) newErrors.date = "Enter a valid expiration date";
    if (!card) newErrors.card = "Enter a card number";
    if (!security)
      newErrors.security = "Enter the CVV or security code on your card";
    if (!firstName) newErrors.firstName = "Enter a first name";
    if (!lastName) newErrors.lastName = "Enter a last name";
    if (!address) newErrors.address = "Enter an address";
    if (!city) newErrors.city = "Enter a city";
    if (!cardName)
      newErrors.cardName =
        "Enter your name exactly as it's written on your card";

    // setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      alert("Please fill all fields");
    } else {
      alert("Order placed!");
      clearCart();
      navigate("/paysuccess");
    }
  };

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const product = getProductById(item.id);
      if (!product) return total;

      const price = parseFloat(product.price, 10);
      return total + price * item.quantity;
    }, 0);
  };

  const formatCardNumber = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    value = value.replace(/\d{4}(?=\d)/g, "$& ");
    value = value.substring(0, 19);
    setCard(value);
  };

  const formatDate = (e) => {
    let { value } = e.target;
    // 只允许输入数字和斜杠
    value = value.replace(/[^\d/]/g, "");
    if (value.length > 1 && value.indexOf("/") === -1) {
      value += "/";
    }
    value = value.substring(0, 5);
    setDate(value);
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <body
      id="ban-do-we-exist-to-help-you-be-your-best"
      className="template-index theme-animate-hover"
    >
      <div className="main-containerCheck">
        <div className="check-custom-checkout-page">
          <div className="left">
            <div className="check-order-info">
              <form>
                <div className="form-group">
                  <label>Contact</label>
                  <input
                    type="text"
                    id="contact"
                    name="contact"
                    value={contact}
                    placeholder="Email or mobile phone number"
                    onChange={(e) => setContact(e.target.value)}
                    required
                  />
                  {errors.contact && <p className="error">{errors.contact}</p>}
                </div>

                <div className="form-group">
                  <label>Delivery</label>
                  <ReactFlagsSelect
                    selected={countryCode}
                    onSelect={(code) => setCountryCode(code)}
                    className="check-select"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={firstName}
                      placeholder="First name *"
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                    {errors.firstName && (
                      <p className="error">{errors.firstName}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={lastName}
                      placeholder="Last name *"
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                    {errors.lastName && (
                      <p className="error">{errors.lastName}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="company-name"
                    name="company-name"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    placeholder="Company name (optional)"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                    placeholder="Address"
                  />
                  {errors.address && <p className="error">{errors.address}</p>}
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="address1"
                    name="address1"
                    value={address1}
                    onChange={(e) => setAddress1(e.target.value)}
                    required
                    placeholder="Apartment, suite, etc. (optional)"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={city}
                      placeholder="city"
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                    {errors.city && <p className="error">{errors.city}</p>}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="postalCode"
                      name="postalCode"
                      value={postalCode}
                      placeholder="Postal code"
                      onChange={(e) => setPostalCode(e.target.value)}
                      required
                    />
                    {errors.postalCode && (
                      <p className="error">{errors.postalCode}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label>Shipping method</label>
                  <input
                    type="text"
                    id="ship"
                    name="ship"
                    value={ship}
                    onChange={(e) => setShip(e.target.value)}
                    required
                    placeholder="Enter your shipping address to view available shipping methods."
                  />
                </div>

                <br />
                <br />
                <div className="form-group">
                  <label>Payment</label>
                  <div className="payment-box">
                    <div className="payment-header">
                      <div className="payment-header-left">Credit card</div>
                      <div className="payment-header-right">
                        <img
                          alt="Visa"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/visa.sxIq5Dot.svg"
                        />
                        <img
                          alt="Mastercard"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/mastercard.1c4_lyMp.svg"
                        />
                        <img
                          alt="Amex"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/amex.Csr7hRoy.svg"
                        />
                        <img
                          alt="Discover"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/discover.C7UbFpNb.svg"
                        />
                      </div>
                    </div>
                    <div className="payment-body">
                      <input
                        type="text"
                        value={card}
                        name="cardNumber"
                        onChange={formatCardNumber}
                        placeholder="Card Number"
                      />
                      {errors.card && <p className="error">{errors.card}</p>}
                      <div className="form-row">
                        <input
                          type="text"
                          value={date}
                          name="date"
                          onChange={formatDate}
                          placeholder="Expiration date (MM / YY)"
                        />
                        <input
                          type="text"
                          value={security}
                          name="security"
                          onChange={(e) => setSecurity(e.target.value)}
                          placeholder="Security code"
                        />
                      </div>
                      <input
                        type="text"
                        value={cardName}
                        name="cardName"
                        onChange={(e) => setCardName(e.target.value)}
                        placeholder="Name on card"
                      />
                      {errors.cardName && (
                        <p className="error">{errors.cardName}</p>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <button
                className="check-checkout-button"
                onClick={handlePlaceOrder}
              >
                Pay Now
              </button>

              <p>
                <Link
                  to="/returns"
                  style={{ textDecoration: "underline" }}
                  onClick={toTop}
                >
                  Shipping & Returns Info
                </Link>
              </p>
            </div>
          </div>

          {!sub && (
            <div className="right">
              <div className="check-order-summary">
                <div className="check-order-details">
                  {cartItems.map((item, index) => {
                    const product = getProductById(item.id);
                    if (!product || !product.images) return null;
                    return (
                      <div key={index} className="check-cart-item">
                        <img src={product.images[0]} alt="Product" />
                        <div className="pro--qty">
                          <div className="qty-inner">{item.quantity}</div>
                        </div>
                        <div className="check-item-details">
                          <h3>
                            {product.name}
                            {item.size && (
                              <>
                                <br />
                                Size: {item.size}
                              </>
                            )}
                            {item.color && (
                              <>
                                <br />
                                Color: {item.color}
                              </>
                            )}
                          </h3>
                        </div>
                        <p className="cal-single">${product.price} </p>
                      </div>
                    );
                  })}

                  <div className="check-summary-details">
                    <div className="gridTotal">
                      <table className="summary-details22">
                        <tbody className="sumTbody22">
                          <tr className="sumTr22">
                            <th
                              className="subtotalTh22"
                              style={{ fontSize: "24px" }}
                            >
                              Total
                            </th>
                            <th className="subtotalTxt22">
                              ${calculateTotal().toFixed(2)}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </body>
  );
};

export default CheckOut;
